import React from "react";
import {
  Box,
  Typography,
  Radio,
  Collapse,
  TextField,
  Alert,
} from "@mui/material";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PhoneIcon from "@mui/icons-material/Phone";
import PaymentsIcon from "@mui/icons-material/Payments";
import CreditCardIcon from "@mui/icons-material/CreditCard";
const paymentMethods = [
  // {
  //   value: "CreditCard",
  //   title: "תשלום בכרטיס אשראי",
  //   description:
  //     "הזנת פרטי האשראי תתבצע בעמוד התשלום המאובטח של ריווחית",
  //   icon: (
  //     <CreditCardIcon
  //       sx={{
  //         fontSize: 30,
  //         color: "#37474f",
  //       }}
  //     />
  //   ),
  // },
  {
    value: "BankTransfer",
    title: "העברה בנקאית",
    description:
      "נציג יצור איתך קשר למסירת פרטי ההעברה",
    icon: (
      <AccountBalanceIcon
        sx={{
          fontSize: 30,
          color: "#37474f",
        }}
      />
    ),
  },
  {
    value: "PhonePayment",
    title: "תשלום טלפוני",
    description:
      "נציג יצור איתך קשר לביצוע התשלום",
    icon: (
      <PhoneIcon
        sx={{
          fontSize: 30,
          color: "#37474f",
        }}
      />
    ),
  },
  {
    value: "TicketCard",
    title: "טיצר כארד / כארד כל",
    description: "",
    icon: (
      <PaymentsIcon
        sx={{
          fontSize: 30,
          color: "#37474f",
        }}
      />
    ),
  },
];

const PaymentMethodSelector = ({
  value,
  onChange,
  error,
}) => {
  return (
    <Box
      dir="rtl"
      sx={{
        mt: 1,
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflowX: "hidden",
        direction: "rtl",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          fontWeight: 700,
          textAlign: "right",
        }}
      >
        בחירת אמצעי תשלום
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          direction: "rtl",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        {paymentMethods.map((method) => {
          const selected = value === method.value;

          return (
            <Box
              key={method.value}
              onClick={() => onChange(method.value)}
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                border: "1px solid",
                borderColor: selected
                  ? "#D81B60"
                  : "#dde2e7",
                borderRadius: 2,
                overflow: "hidden",
                cursor: "pointer",
                backgroundColor: selected ? "#fff7fa" : "#fff",
                transition: "all 0.2s ease",
                direction: "rtl",
                boxShadow: selected
                  ? "0 4px 14px rgba(216, 27, 96, 0.12)"
                  : "none",

                "&:hover": {
                  borderColor: "#D81B60",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  boxSizing: "border-box",
                  overflow: "hidden",
                  minHeight: 72,

                  px: {
                    xs: 1,
                    sm: 2,
                  },

                  py: 1.5,

                  display: "flex",
                  alignItems: "center",

                  gap: {
                    xs: 1,
                    sm: 1.5,
                  },

                  direction: "rtl",
                }}
              >
                <Radio
                  checked={selected}
                  value={method.value}
                  onChange={() => onChange(method.value)}
                  onClick={(event) => event.stopPropagation()}
                  sx={{
                    p: 0.5,
                    color: "#adb5bd",

                    "&.Mui-checked": {
                      color: "#D81B60",
                    },
                  }}
                />

                <Box
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    textAlign: "right",
                    direction: "rtl",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      lineHeight: 1.4,
                      whiteSpace: "normal",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {method.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      mt: 0.3,
                      whiteSpace: "normal",
                      lineHeight: 1.5,
                    }}
                  >
                    {method.description}
                  </Typography>
                </Box>

                {method.icon && (
                  <Box
                    sx={{
                      minWidth: {
                        xs: 38,
                        sm: 52,
                      },
                      width: {
                        xs: 38,
                        sm: 52,
                      },
                      minHeight: 42,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    {method.icon}
                  </Box>
                )}
              </Box>

              <Collapse in={selected}>
                {/* {method.value === "CreditCard" && (
  <Box
    sx={{
      px: 2,
      pb: 2,
      pr: {
        xs: 2,
        sm: 7,
      },
    }}
  >
    <Alert
      severity="info"
      sx={{
        direction: "rtl",
        textAlign: "right",

        "& .MuiAlert-icon": {
          ml: 1,
          mr: 0,
        },
      }}
    >
      לאחר אישור ההזמנה תועברי לעמוד הסליקה המאובטח,
      שם תוכלי להזין את פרטי האשראי ולבחור את מספר התשלומים.
    </Alert>
  </Box>
)} */}

                {method.value === "BankTransfer" && (
                  <Box
                    sx={{
                      px: 2,
                      pb: 2,
                      pr: {
                        xs: 2,
                        sm: 7,
                      },
                    }}
                  >
                    <Alert
                      severity="info"
                      sx={{
                        direction: "rtl",
                        textAlign: "right",

                        "& .MuiAlert-icon": {
                          ml: 1,
                          mr: 0,
                        },
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        boxSizing: "border-box",
                      }}
                    >
                      נציג יצור איתך קשר טלפוני לצורך השלמת התשלום.
                    </Alert>
                  </Box>
                )}

                {method.value === "PhonePayment" && (
                  <Box
                    sx={{
                      px: 2,
                      pb: 2,
                      pr: {
                        xs: 2,
                        sm: 7,
                      },
                    }}
                  >
                    <Alert
                      severity="info"
                      sx={{
                        direction: "rtl",
                        textAlign: "right",

                        "& .MuiAlert-icon": {
                          ml: 1,
                          mr: 0,
                        },
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        boxSizing: "border-box",
                      }}
                    >
                      נציג יצור איתך קשר טלפוני לצורך השלמת התשלום.
                    </Alert>
                  </Box>
                )}

                {method.value === "TicketCard" && (
                  <Box
                    sx={{
                      px: 2,
                      pb: 2,
                      pr: {
                        xs: 2,
                        sm: 7,
                      },
                    }}
                  >
                    <Alert
                      severity="info"
                      sx={{
                        direction: "rtl",
                        textAlign: "right",

                        "& .MuiAlert-icon": {
                          ml: 1,
                          mr: 0,
                        },
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        boxSizing: "border-box",
                      }}
                    >
                      נציג יצור אתך קשר לקבלת מספר וקוד הכרטיס
                    </Alert>
                  </Box>
                )}
              </Collapse>
            </Box>
          );
        })}
      </Box>

      {error && (
        <Typography
          variant="body2"
          sx={{
            color: "error.main",
            mt: 1,
            textAlign: "right",
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default PaymentMethodSelector;